import { render, staticRenderFns } from "./UpdateOrderState.vue?vue&type=template&id=4622f1cc&"
import script from "./UpdateOrderState.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports